import { ChatMessage as ChatMessageType } from '../../interfaces/chat';
import { ChatMarkdown } from './ChatMarkdown';

interface Props {
    message: ChatMessageType;
    countryCode?: string;
    projectTitle?: string;
    onRetry?: () => void;
}

export const ChatMessage = ({ message, countryCode, projectTitle, onRetry }: Props) => {
    const isUser = message.role === 'user';

    return (
        <div className={`tw-flex ${isUser ? 'tw-justify-end' : 'tw-justify-start'}`}>
            <div
                className={`tw-max-w-[85%] tw-rounded-2xl tw-px-4 tw-py-2
                           ${isUser
                        ? 'tw-bg-primary tw-text-white tw-rounded-br-sm'
                        : 'tw-bg-white tw-shadow-sm tw-border tw-border-gray-100 tw-rounded-bl-sm'
                    }`}
            >
                {isUser ? (
                    <p className="tw-whitespace-pre-wrap tw-text-sm tw-m-0">{message.content}</p>
                ) : (
                    <>
                        <ChatMarkdown content={message.content} isStreaming={message.isStreaming} countryCode={countryCode} projectTitle={projectTitle} />
                        {message.isTruncated && onRetry && (
                            <button
                                onClick={onRetry}
                                className="tw-mt-2 tw-text-xs tw-text-primary tw-bg-primary/10 tw-border tw-border-primary/20 tw-rounded-lg tw-px-3 tw-py-1.5 tw-cursor-pointer hover:tw-bg-primary/20 tw-transition-colors"
                            >
                                Reintentar respuesta
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ChatMessage;
